import React, { lazy } from "react";

export const JobsMetadata = {
  name: "Jobs",
  id: "jobs_list",
  component: lazy(() => import("../Jobs/Jobs")),
  route: "/jobs",
  Breadcrumbs: true,
};

export const JobsMetadataDetails = {
  name: "JobsDetails",
  id: "jobs_details",
  component: lazy(() => import("../Jobs/JobsDetailsView")),
  route: "/jobs",
  Breadcrumbs: true,
};
